import en from './en'
import zh from './zh'
import czh from './czh'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import czhLocale from 'element-ui/lib/locale/lang/zh-TW'

export default {
    en_US: {
        ...en,
        ...enLocale // 或者用 Object.assign({ ...en }, enLocale)
    },
    zh_CN: {
        ...zh,
        ...zhLocale // 或者用 Object.assign({ ..zh }, zhLocale)
    },
    zh_TW: {
        ...czh,
        ...czhLocale // 或者用 Object.assign({ ..czh }, czhLocale)
    }
}